import { isGroup } from '../../option/utils/filter-options';
import { getOptionId } from '../../options-list/utils/use-ids';
/** Group headers can be highlighted only when groups are interactive. */
export const isHighlightable = (option, interactiveGroups) => !!option && (interactiveGroups || option.type !== 'parent');
// Only group neighbours use group state. Select-all never counts as a selected neighbour, so the row
// below it doesn't get the previous-item-selected style.
const isSelectedNeighbour = (option, { selectedSet, selection }) => !!option && isGroup(option.option)
    ? selection.getGroupState(option).selected
    : selectedSet.has(option);
/** Props for one listbox row. */
export function getListboxOptionProps(option, index, context) {
    const { options, selectedSet, selection, highlightedOption, interactiveGroups, listId } = context;
    const isSelectAll = option.type === 'select-all';
    const groupState = isSelectAll || isGroup(option.option) ? selection.getGroupState(option) : undefined;
    const selected = isSelectAll ? !!(groupState === null || groupState === void 0 ? void 0 : groupState.selected) : selectedSet.has(option) || !!(groupState === null || groupState === void 0 ? void 0 : groupState.selected);
    const optionProps = {
        key: index,
        option,
        highlighted: option === highlightedOption,
        selected,
        isNextSelected: isSelectedNeighbour(options[index + 1], context),
        isPreviousSelected: isSelectedNeighbour(options[index - 1], context),
        indeterminate: !!(groupState === null || groupState === void 0 ? void 0 : groupState.indeterminate),
        ['data-mouse-target']: isHighlightable(option, interactiveGroups) ? index : -1,
        id: getOptionId(listId, index),
    };
    return optionProps;
}
/** The option to choose: `option`, or the highlighted option when omitted. Undefined when it isn't interactive. */
export const getSelectableOption = (option, highlightedOption, interactivityCheck) => {
    const optionToSelect = option || highlightedOption;
    return optionToSelect && interactivityCheck(optionToSelect) ? optionToSelect : undefined;
};
/** Mouse handlers for the list. An item index of -1 means the pointer isn't over a highlightable option. */
export const getListMouseHandlers = ({ options, selectOption, setHighlightedIndexWithMouse, }) => ({
    onMouseUp: (itemIndex) => {
        if (itemIndex > -1) {
            selectOption(options[itemIndex]);
        }
    },
    onMouseMove: (itemIndex) => {
        if (itemIndex > -1) {
            setHighlightedIndexWithMouse(itemIndex);
        }
    },
});
/** Whether the live region announces the highlighted option as selected. */
export const isAnnouncedSelected = (highlightedOption, selectedSet, selection) => !!highlightedOption &&
    (selectedSet.has(highlightedOption) ||
        (isGroup(highlightedOption.option) && selection.getGroupState(highlightedOption).selected));
//# sourceMappingURL=option-props.js.map